export * from '../infra/mixpanel';
export { Mixpanel as default } from '../infra/mixpanel';
